export class ChangePasswordModel{
    EmailId: string ; 
    OldPassword: string ;
    NewPassword: string ;
    ConfirmPassword:string;
}


// WEBPACK FOOTER //
// ./src/app/models/ChangePasswordModel.ts